"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var layout_utils_1 = require("../../../../utils/layout-utils");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var lodash_1 = require("lodash");
var SubFormSettingsModel = /** @class */ (function () {
    function SubFormSettingsModel() {
    }
    SubFormSettingsModel.initialSettings = function (languages) {
        var settings = new SubFormSettingsModel();
        settings.width = 600;
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        languages.forEach(function (language) {
            multilingualStringBuilder.withValueForLanguage(language.getId(), '');
        });
        settings.title = multilingualStringBuilder.build();
        return settings;
    };
    SubFormSettingsModel.toJson = function (settings) {
        return {
            width: settings.width + 'px',
            titleString: layout_utils_1.LayoutUtils.multiLingualToJson(settings.title),
        };
    };
    SubFormSettingsModel.fromJson = function (jsObject) {
        var settings = new SubFormSettingsModel();
        settings.width = Number(lodash_1.split(idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'width', '600px'), 'px', 1)[0]);
        settings.title = layout_utils_1.LayoutUtils.getMultiLingualText(idm_dynamic_layout_interpreter_1.getOptionalProperty(jsObject, 'titleString'));
        return settings;
    };
    return SubFormSettingsModel;
}());
exports.SubFormSettingsModel = SubFormSettingsModel;
//# sourceMappingURL=sub-form-settings.model.js.map